import { api } from './api';

export const getTeachers = (params?: { search?: string; cursor?: string; limit?: number }) =>
  api.get('/admin/users', { params: { ...params, role: 'TEACHER' } });
